import { addMinutes } from 'date-fns';
import { listAppointments } from '../../api/appointments';

const BLOCKING_APPOINTMENT_STATUSES = new Set([
  'confirmed',
  'pending',
  'pending_payment',
  'rescheduled',
  'processing',
]);

function parseDate(value) {
  if (!value) return null;
  if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value;
  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

function appointmentDurationMinutes(appointment, fallback = 60) {
  const addons = Array.isArray(appointment.selectedAddons) ? appointment.selectedAddons : [];
  const addonMinutes = addons.reduce(
    (total, addon) =>
      total + parseInt(addon.duration || 0, 10) + parseInt(addon.bufferTime || 0, 10),
    0
  );
  const duration = parseInt(appointment.duration || 0, 10);
  const buffer = parseInt(appointment.bufferTime || 0, 10);
  const total = duration + buffer + addonMinutes;
  return total > 0 ? total : fallback;
}

export async function listBlockingDayAppointments({ companyId, selectedDate, fallbackDuration = 60 }) {
  const from = new Date(selectedDate);
  from.setHours(0, 0, 0, 0);
  const to = new Date(selectedDate);
  to.setHours(23, 59, 59, 999);
  const result = await listAppointments({ companyId, from, to, archived: false });
  return (result.appointments || [])
    .map((appointment) => {
      const statusKey = String(appointment.status || 'pending').toLowerCase();
      if (!BLOCKING_APPOINTMENT_STATUSES.has(statusKey)) return null;
      const startTime = parseDate(appointment.dateTime);
      if (!startTime) return null;
      const endTime =
        parseDate(appointment.endTime) || addMinutes(startTime, appointmentDurationMinutes(appointment, fallbackDuration));
      if (!endTime) return null;
      return {
        ...appointment,
        id: appointment.id,
        employeeId:
          appointment.employeeId ||
          appointment.staffId ||
          appointment.employee?.id ||
          null,
        startTime,
        endTime,
      };
    })
    .filter(Boolean);
}
